import { UpgradeOption } from 'modules/jogador/classes/types';
import { useToast } from 'shared/components/ui/Toast';

interface UpgradeOptionRowProps {
  option: UpgradeOption;
}

export function UpgradeOptionRow({ option }: UpgradeOptionRowProps) {
  const toast = useToast();

  return (
    <button
      type="button"
      onClick={() =>
        toast({
          title: 'Pedido de upgrade enviado',
          description: `A arena confirma a troca para "${option.title}" a partir da próxima cobrança.`,
        })
      }
      className="flex w-full items-center justify-between rounded-xl border border-border/70 bg-surface p-4 text-left hover:border-primary"
    >
      <div>
        <p className="font-medium text-ink">{option.title}</p>
        <p className="text-sm text-ink-secondary">{option.meta}</p>
      </div>
      <div className="text-right">
        <p className="font-heading font-bold text-ink">R$ {option.price}</p>
        <p className="text-xs text-ink-secondary">{option.priceSuffix}</p>
      </div>
    </button>
  );
}
